import { DpAddressModel } from '@docupet/component-library';

export const AddressMixins = {
  methods: {
    formatAddressStreet: function (address) {
      if (address && address.civic) {
        return address.unit ? address.civic + ' ' + address.street + ' #' + address.unit : address.civic + ' ' + address.street;
      } else if (address && address.additional) {
        return address.additional;
      }

      return '';
    },
    formatAddressCity: (address) => (address?.cityName ? address.cityName + ', ' + address.province + ' ' + address.postal : ''),
    formatAddress: function (address) {
      return [this.formatAddressStreet(address), this.formatAddressCity(address)];
    },
    formatAddressDisplay: function (address) {
      return this.formatAddress(address).join('\n');
    },
    isAddressFilled: (address) =>
      address &&
      ((address?.civic !== '' && address?.street !== '') || address?.addition !== '') &&
      address?.cityName !== '' &&
      address?.province !== '' &&
      address?.postal !== '',
    toAddressObject: (address) => DpAddressModel.fromGQL(address),
    // To do deep comparision we convert obj to same order properties and then compare JSON stings
    compareAddresses: function (addressA, addressB) {
      return JSON.stringify(this.toAddressObject(addressA)) === JSON.stringify(this.toAddressObject(addressB));
    },
  },
};
